import { EVENT_BEHAVIORS_LABELS, SafetyTagsBucket } from '@lib/safety/safety';
import { COMPLIANCE_COACHABLE_BEHAVIORS_LABELS, ComplianceTagsBucket } from '@lib/compliance-utils';

export type CoachableTagsBucketTooltip = { [key in SafetyTagsBucket | ComplianceTagsBucket | 'other']: string[] };

export const COACHING_WEEKS: number = 12;

export const COACHING_URL_PREFIX: string = '/coaching';

type SafetyFeature = 'safety';
type ComplianceFeature = 'compliance' ;

export type CoachingFeatureType = SafetyFeature | ComplianceFeature;

export const SAFETY_FEATURE: SafetyFeature = 'safety';
export const COMPLIANCE_FEATURE: ComplianceFeature = 'compliance';

export enum COACHING_SESSION_CATEGORY {
  SAFETY = 'safety',
  COMPLIANCE = 'compliance',
}

export const COACHABLE_TAGS_BUCKET_TOOLTIP: CoachableTagsBucketTooltip = {
  core_risk:
  [
    EVENT_BEHAVIORS_LABELS.unsafe_lane_change,
    EVENT_BEHAVIORS_LABELS.tailgating,
    EVENT_BEHAVIORS_LABELS.cut_off,
  ],
  violations:
  [
    EVENT_BEHAVIORS_LABELS.ran_a_red_light,
    EVENT_BEHAVIORS_LABELS.stop_sign_violation,
    EVENT_BEHAVIORS_LABELS.speeding,
  ],
  driver_awareness:
  [
    EVENT_BEHAVIORS_LABELS.seat_belt_violation,
    EVENT_BEHAVIORS_LABELS.distraction,
    EVENT_BEHAVIORS_LABELS.drowsiness,
    EVENT_BEHAVIORS_LABELS.smoking,
    EVENT_BEHAVIORS_LABELS.cell_phone,
    EVENT_BEHAVIORS_LABELS.camera_obstruction,
  ],
  harsh_driving:
  [
    EVENT_BEHAVIORS_LABELS.hard_brake,
    EVENT_BEHAVIORS_LABELS.hard_accel,
    EVENT_BEHAVIORS_LABELS.hard_corner,
  ],
  other:
  [
    EVENT_BEHAVIORS_LABELS.forward_collision_warning,
    EVENT_BEHAVIORS_LABELS.crash,
    EVENT_BEHAVIORS_LABELS.manual_event,
    EVENT_BEHAVIORS_LABELS.near_miss,
  ],
  hos_violations:
  [
    COMPLIANCE_COACHABLE_BEHAVIORS_LABELS.shift_violations,
    COMPLIANCE_COACHABLE_BEHAVIORS_LABELS.cycle_violations,
    COMPLIANCE_COACHABLE_BEHAVIORS_LABELS.driving_violations,
    COMPLIANCE_COACHABLE_BEHAVIORS_LABELS.break_violations,
    COMPLIANCE_COACHABLE_BEHAVIORS_LABELS.off_duty_violations,
    COMPLIANCE_COACHABLE_BEHAVIORS_LABELS.exception_violations,
  ],
  fm_errors:
  [
    COMPLIANCE_COACHABLE_BEHAVIORS_LABELS.signature,
    COMPLIANCE_COACHABLE_BEHAVIORS_LABELS.shipping_info,
    COMPLIANCE_COACHABLE_BEHAVIORS_LABELS.carrier_address,
    COMPLIANCE_COACHABLE_BEHAVIORS_LABELS.miles,
    COMPLIANCE_COACHABLE_BEHAVIORS_LABELS.tractor_num,
    COMPLIANCE_COACHABLE_BEHAVIORS_LABELS.odometers,
    COMPLIANCE_COACHABLE_BEHAVIORS_LABELS.carrier_name,
  ],
};

export const MERGED_COACHABLE_BEHAVIORS_LABELS = {...EVENT_BEHAVIORS_LABELS, ...COMPLIANCE_COACHABLE_BEHAVIORS_LABELS};
